import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';
import { combineActions } from 'redux-zero/utils';
import { Link } from 'react-router-dom';
import {
  vEmail,
  vMinLength,
  vIncludeUppercase,
  vIncludeLowercase,
  vIncludeNumber,
  vOneOf,
} from '@tokenyico/design-system';
import { DsForm, DsInputString, DsButton } from '@tokenyico/design-system/dist/reactJS';

import { formActions, holderActions } from 'app/state/actions';
import { AuthenticationService } from 'services';

const mapToProps = (state) => state;

const ResetPasswordAuthView = ({ history, location, setError, setSuccess }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(null);
  const [code, setCode] = useState(null);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const query = new URLSearchParams(location.search);
  let emailFromUrl = null;
  if (query.get('email')) {
    emailFromUrl = query.get('email');
  } else if (location.state && location.state.email !== undefined) {
    emailFromUrl = location.state.email;
  }

  useEffect(() => {
    if (emailFromUrl !== null) {
      setEmail(emailFromUrl);
    } else {
      history.push('/auth/forgot-password');
    }
  }, [history, emailFromUrl]);

  async function onSubmit() {
    setIsSubmitting(true);
    try {
      await AuthenticationService.forgotPasswordConfirm({ username: email, code, password });
      history.push('/auth/signin', { email });
      setSuccess(t('shared.resetPasswordSuccess'));
      setIsSubmitting(false);
    } catch (error) {
      if (error.code === 'CodeMismatchException') {
        setError(t('validation.verificationCodeInvalid'));
      } else if (error.code === 'ExpiredCodeException') {
        setError(t('validation.verificationCodeExpired'));
      } else {
        setError(error);
      }
      setIsSubmitting(false);
    }
  }

  async function onClickResendUserCode(e) {
    e.preventDefault();
    try {
      await AuthenticationService.forgotPassword(email);
      setSuccess(t('shared.checkEmail'));
    } catch (error) {
      setError(error);
    }
  }

  return (
    <div className="card auth">
      <h1 className="auth__title">{t('shared.resetPassword')}</h1>
      <DsForm onSubmit={onSubmit} id="reset-password">
        <div style={{ visibility: 'hidden', height: 0 }}>
          <DsInputString
            label={t('shared.email')}
            isFloatLabel={false}
            name="email"
            type="email"
            value={email}
            onDsInput={({ detail }) =>
              setEmail(typeof detail === 'string' ? detail.toLocaleLowerCase() : detail)
            }
            validate={vEmail}
          />
        </div>
        <div className="_flex-row _m:bottom(4) _text:sm" style={{ color: 'var(--grey-900)' }}>
          <span dangerouslySetInnerHTML={{ __html: t('shared.confirmCode', { email }) }} />
        </div>
        <DsInputString
          label={t('shared.confirmationCode')}
          isFloatLabel={false}
          name="code"
          value={code}
          onDsInput={({ detail }) => setCode(detail && detail.trim())}
          validate={vMinLength(6)}
          className="_m:top(2)"
        />
        <DsInputString
          label={t('shared.password')}
          isFloatLabel={false}
          name="password"
          type="password"
          value={password}
          onDsInput={({ detail }) => setPassword(detail)}
          validate={(v) =>
            vMinLength(8)(v) || vIncludeUppercase(v) || vIncludeLowercase(v) || vIncludeNumber(v)
          }
          className="_m:top(2)"
        />
        <DsInputString
          label={t('shared.confirmPassword')}
          isFloatLabel={false}
          name="confirmPassword"
          type="password"
          value={confirmPassword}
          onDsInput={({ detail }) => setConfirmPassword(detail)}
          validate={(v) =>
            vOneOf([password])(v) ? t('validation.passwordConfirmMatch') : undefined
          }
          className="_m:top(2)"
        />

        <div className="auth__button-primary">
          <DsButton
            version="primary"
            label={t('shared.resetPassword')}
            type="submit"
            isLoading={isSubmitting}
            icon="arrow-right"
            iconHeight={11}
          />
        </div>
        <div className="auth__button-secondary">
          <DsButton
            label={t('shared.iDidNotGetTheEmail')}
            mode="text"
            onClick={onClickResendUserCode}
          />
        </div>
      </DsForm>
      <div className="auth__footer">
        <Link to="/">
          <DsButton label={t('shared.backToSignIn')} mode="text" id="sign-in" />
        </Link>
      </div>
    </div>
  );
};

export default connect(
  mapToProps,
  combineActions(formActions, holderActions),
)(ResetPasswordAuthView);
